import axios from 'axios';
import _ from 'lodash';

import cfg from '../config';

export const IS_PUBLISHING = "publish/IS_PUBLISHING";
export const HAS_PUBLISHED = "publish/HAS_PUBLISHED";
export const CLOSE_PREVIEW = 'publish/CLOSE_PREVIEW';
export const OPEN_PREVIEW = 'publish/OPEN_PREVIEW';
export const SET_APPROVE_PREVIEW = 'publish/SET_APPROVE_PREVIEW';

const initialState = {
  isPublishing: false,
  isPreviewing: false,
  previewDetails: {
    displayName: '',
    layer: '',
    workspace: '',
    apikey: '',
    isApproved: false,
  },
  timestamp: Date.now()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case IS_PUBLISHING:
      return {
        ...state,
        isPublishing: true,
        timestamp: Date.now()
      };
    case HAS_PUBLISHED:
      return {
        ...state,
        isPublishing: false,
        timestamp: Date.now()
      };
    //
    case CLOSE_PREVIEW:
      return {
        ...state,
        isPreviewing: false,
        previewDetails: {
          layer: '',
          apikey: '',
          isApproved: false,
        },
        timestamp: Date.now()
      };
      case OPEN_PREVIEW:
        return {
          ...state,
          isPreviewing: true,
          previewDetails: {
            displayName: action.displayName,
            layer: action.layer,
            workspace: action.workspace,
            apikey: action.apikey,
            isApproved: false,
          },
          timestamp: Date.now()
        };
    case SET_APPROVE_PREVIEW:
        const clonedPreviewDetails = _.cloneDeep(state.previewDetails);
        clonedPreviewDetails.isApproved = action.value ? true : false;
        return {
          ...state,
          previewDetails: clonedPreviewDetails,
          timestamp: Date.now()
        };
    default:
      return state;
  }
}

export const closePreview = () => {
  return dispatch => {
      dispatch({type: CLOSE_PREVIEW });
  }
}

export const setApprovePreview = (b) => {
  return dispatch => {
      dispatch({type: SET_APPROVE_PREVIEW, value: b });
  }
}

export const openPreview = (workspace, layer, displayName, apikey) => {
  return dispatch => {
      dispatch({type: OPEN_PREVIEW, layer: layer, workspace: workspace, displayName: displayName, apikey: apikey });
  }
}


export const publishWmsLayer = (id) => {
  return dispatch => {
      dispatch({type: IS_PUBLISHING});
      axios.post(`${cfg.api.publishWmsLayer}${id}`)
      .then((response) => {
          dispatch({type: HAS_PUBLISHED });
      })
      .catch((error) => {
         console.log(error);
         dispatch({type: HAS_PUBLISHED});
      });
  }
}

/*
export const resetDetails = () => {
  return dispatch => {
      dispatch({type: DATA_RESET_DETAILS});
  }
}
*/



// WEBPACK FOOTER //
// ./src/reducers/publish.js